import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchUserNumberSubscription,
  fetchUserNumberSubscriptions,
} from "../../actions/callrecorder/userNumberSubscriptionsActions";

export interface UserNumberSubscriptionInterface {
  url: string;

  id: number;
  user_id: number;
  user_number_id: number;
  number: string;
  phone_number_price_history_id: number;
  phn_subscription_plan_id: number | null;
  plan_name: string | null;
  status: string;
  auto_renew: boolean;
  started_at: string;
  current_period_start: string;
  current_period_end: string;
  cancelled_at: string | null;
  twilio_released_at: string | null;
  monthly_fee: string | null;
  days_remaining: number | null;
  incoming_sms_count: number;
  total_incoming_sms_limit: number;
  extra_incoming_sms_count: number;

  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<UserNumberSubscriptionInterface>();

const slice = createSlice({
  name: 'userNumberSubscriptions',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchUserNumberSubscriptions.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchUserNumberSubscriptions.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.userNumberSubscriptions;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchUserNumberSubscriptions.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchUserNumberSubscription.fulfilled, (state, action) => {
        const record = Object.values(action.payload.userNumberSubscription)[0];
        state.entities[record.id] = record;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectUserNumberSubscriptionById,
  selectIds: selectUserNumberSubscriptionIds,
  selectEntities: selectUserNumberSubscriptionEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.userNumberSubscriptions);
